export const AUTH_TAG = 'AUTH_TAG';
export const USERS_TAG = 'USERS_TAG';
export const CONFIG_TAG = 'CONFIG_TAG';
export const CONFIG_BASE_URL_TAG = 'CONFIG_BASE_URL_TAG';
export const CONFIG_EMAIL_TAG = 'CONFIG_EMAIL_TAG';
export const CONFIG_SMS_TAG = 'CONFIG_SMS_TAG';
export const CONFIG_TELEGRAM_TAG = 'CONFIG_TELEGRAM_TAG';
export const CONFIG_TELEGRAM_CHAT_ROUTING_TAG = 'CONFIG_TELEGRAM_CHAT_ROUTING_TAG';
export const CONFIG_IMAGES_TAG = 'CONFIG_IMAGES_TAG';
export const CURRENCIES_TAG = 'CURRENCIES_TAG';
export const PAYMENTS_TAG = 'PAYMENTS_TAG';
export const PAYMENTS_STATS_TAG = 'PAYMENTS_STATS_TAG';
export const STATISTICS_TAG = 'STATISTICS_TAG';
export const WITHDRAWALS_TAG = 'WITHDRAWALS_TAG';
export const SHOPS_TAG = 'SHOPS_TAG';
export const PAYMENT_SYSTEMS_TAG = 'PAYMENT_SYSTEMS_TAG';
export const PAYMENT_METHODS_TAG = 'PAYMENT_METHODS_TAG';
export const WITHDRAWAL_METHODS_TAG = 'WITHDRAWAL_METHODS_TAG';
export const REMOTE_PAYMENT_METHODS_TAG = 'REMOTE_PAYMENT_METHODS_TAG';
export const WHITELIST_TAG = 'WHITELIST_TAG';
export const SHOP_COMMISSIONS_TAG = 'SHOP_COMMISSIONS_TAG';
export const CONVERSION_PAIRS_TAG = 'CONVERSION_PAIRS_TAG';
